(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gm-vehicle-finder"] && !Shopify.designMode) return;
  try {
    
function gmInitFinder(root){
 if(root.dataset.ready)return;root.dataset.ready='true';
 const data=JSON.parse(root.querySelector('[data-gm-vehicles]').textContent);
 const form=root.querySelector('form'),make=form.elements.make,model=form.elements.model,year=form.elements.year,button=form.querySelector('button');
 function fill(select,values){select.length=1;values.sort((a,b)=>select.name==='year'?b.localeCompare(a,undefined,{numeric:true}):a.localeCompare(b,undefined,{numeric:true})).forEach(v=>select.add(new Option(v,v)));select.disabled=!values.length;}
 fill(make,Object.keys(data));
 make.addEventListener('change',()=>{fill(model,Object.keys(data[make.value]||{}));fill(year,[]);button.disabled=true;});
 model.addEventListener('change',()=>{fill(year,Object.keys(data[make.value]?.[model.value]||{}));button.disabled=true;});
 year.addEventListener('change',()=>{button.disabled=!year.value;});
 form.addEventListener('submit',e=>{e.preventDefault();const tag=data[make.value]?.[model.value]?.[year.value];if(tag)window.location.assign(root.dataset.url+'/'+encodeURIComponent(tag));});
}
document.querySelectorAll('[data-gm-finder]').forEach(gmInitFinder);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-gm-finder]').forEach(gmInitFinder));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
